import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

export const PolicesPanel = () => {
  const [PoliciesData, setPoliciesData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/policy_list"
      );
      setPoliciesData(response.data.data);
    };

    fetchData();
  }, []);

  const deleteUser = async (userId) => {
    try {
      const response = await axios.post(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/delete_policy",
        { policy_id: userId },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success === 1) {
        setPoliciesData((prevUser) =>
          prevUser.filter((user) => user.policy_id !== userId)
        );
        toast.error("Data Deleted Successfully!");
        navigate("/Policies");
      } else {
        toast.error(response.data.error || "Delete failed.");
      }
    } catch (error) {
      console.error("There was an error!", error);
    }
  };

  return (
    <div className="container mt-5">
      <div className="add-btn">
        <Link to="/Policies-add">
          <button className="btn btn-success text-white">Add Policies</button>
        </Link>
      </div>
      <table className="table table-bordered table-striped">
        <thead className="">
          <tr>
            <th colSpan="4" className=" text-center bg-white fs-4 text-black">
              Policies Table
            </th>
          </tr>
          <tr>
            <th style={{ width: "80%" }} className="text-white text-center table-custom">
              Policies
            </th>
            <th style={{ width: "20%" }} className="text-white text-center table-custom">
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {PoliciesData.map((Data, index) => (
            <tr key={index}>
              <td style={{ width: "80%" }}>{Data.policy_details}</td>
              <td style={{ width: "20%" }} className="text-center">
                <Link to={`/Edit/Policies/${Data.policy_id}`}>
                  <button className="btn btn-primary btn-sm me-1">
                    <i className="fa-regular fa-pen-to-square text-white"></i>
                  </button>
                </Link>
                <button
                  className="btn btn-danger btn-sm me-1"
                  onClick={() => deleteUser(Data.policy_id)}
                >
                 <i className="fa-regular fa-trash-can text-white"></i>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export const PoliciesAdd = () => {
  const users = {
    policy_details: "",
  };
  const [PolociesUser, setPolociesUser] = useState(users);
  const navigate = useNavigate();

  const inputHandler = (e) => {
    const { name, value } = e.target;
    setPolociesUser({ ...PolociesUser, [name]: value });
    console.log(PolociesUser);
  };

  const submitForm = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/add_policy",
        PolociesUser
      );

      if (response.data.success === "1") {
        navigate("/Policies");
        toast.success(response.data.message || "Data Added successfully!");
      } else {
        toast.error(response.data.error || "Failed to add Policies");
      }
    } catch (error) {
      console.error("There was an error!", error);
    }
  };

  return (
    <div className="container mt-5">
      <div className="card shadow-sm">
        <div className="card-header table-custom text-white">
          <h4 className="mb-0 text-white text-center">Add Polices</h4>
        </div>

        <div className="card-body">
          <form className="row g-3" onSubmit={submitForm}>
            <div className="col-md-6">
              <label htmlFor="policy_details" className="form-label">
                Polices
              </label>
              <input
                type="text"
                className="form-control"
                id="policy_details"
                name="policy_details"
                placeholder="Enter Policies"
                value={PolociesUser.policy_details}
                onChange={inputHandler}
              />
            </div>

            <div className="col-12 d-flex justify-content-end">
              <button type="submit" className="btn btn-success" style={{height:"40px"}}>
                Add Polices
              </button>
              <div className="mb-3 ms-2">
                <Link to="/Policies" className="btn btn-secondary">
                  Back
                </Link>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};




export const EditPolicies = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [policyData, setPolicyData] = useState({
    policy_details: "",
  });

  // Fetch policy details
  useEffect(() => {
    const fetchPolicy = async () => {
      try {
        console.log("Fetching policy for ID:", id);
        const response = await axios.post(
          "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/get_policy_by_id",
          {
            policy_id: id,
          }
        );

        setPolicyData(response.data.data);

      } catch (error) {
        console.error("Fetch Error:", error);
        toast.error("Something went wrong while fetching data.");
      }
    };

    if (id) fetchPolicy();
  }, [id]);

  // Handle update
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/update_policy",
        {
          policy_id: id,
          policy_details: policyData.policy_details,
        }
      );

      console.log("Update Response:", response.data);

      if (response.data.success === "1") {
        toast.success("Policy updated successfully!");
        navigate("/Policies");
      } else {
        toast.error("Failed to update policy");
      }
    } catch (error) {
      console.error("Update Error:", error);
      toast.error("Something went wrong while updating.");
    }
  };

    return (
      <div
        className="modal fade show"
        id="update_heading"
        tabIndex={-1}
        role="dialog"
        style={{
          display: "block",
          paddingRight: 18,
          marginTop: 90,
          paddingBottom: 50,
        }}
        aria-modal="true"
      >
        <div className="modal-dialog" role="document">
          <form onSubmit={handleSubmit}>
            <div className="modal-content">
              <div className="modal-header justify-content-center table-custom">
                <h5 className="modal-title text-white">Edit</h5>
              </div>
  
              <div className="modal-body">
                <div className="form-group">
                  <label>Policy Details</label>
                  <textarea
                    type="text"
                    value={policyData.policy_details}
           onChange={(e) =>
             setPolicyData({ ...policyData, policy_details: e.target.value })
           }
                    className="form-control"
                    name="policy_details"
                    id="policy_details"
                    rows={4}
                  />
                </div>
              </div>
  
              <div className="modal-footer">
                <button type="submit" className="btn btn-success">
                  Update
                </button>
                <Link to="/Policies">
                  <button type="button" className="btn btn-secondary">
                    Close
                  </button>
                </Link>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
};


